import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000';
console.log(`API connecting to: ${API_URL} (${process.env.REACT_APP_ENV || 'unknown'} environment)`);

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Elections
export const getElections = () => api.get('/elections');
export const getElection = (id) => api.get(`/elections/${id}`);
export const createElection = (data) => api.post('/elections', data);
export const addCandidates = (electionId, candidates) => api.post(`/elections/${electionId}/candidates`, { candidates });
export const submitVote = (electionId, votes) => api.post(`/elections/${electionId}/vote`, { votes });
export const getElectionResults = (electionId) => api.get(`/elections/${electionId}/tally`);

// System
export const getPublicKey = () => api.get('/public-key');
export const resetDatabase = process.env.REACT_APP_ENV === 'production' 
  ? () => Promise.reject('Not available in production') 
  : () => api.post('/reset');

export default api;